import React, { useState } from "react";
import { Text, Stack, Link } from "@fluentui/react";
import { Card } from "@uifabric/react-cards";
import useAxios from "axios-hooks";
import { useParams } from "react-router-dom";
import ChecklistActionItemsContainer from "./ChecklistActionItemsContainer";
import BasicInfoForm from "../../ActionItems/BasicInfo/BasicInfoForm";
import useCreateActionItem from "./useCreateActionItem";

const ChecklistActionItemsPage = () => {
  let { checklistId } = useParams();
  const [showCreateActionItemForm, setShowCreateActionItemForm] = useState(
    false
  );

  const [
    { loading: putActionItemsLoading },
    putActionItems,
  ] = useAxios(
    {
      url: `/checklist/${checklistId}/action-items`,
      method: "put",
    },
    { manual: true }
  );

  const [{ data: checklist, loading: getChecklistLoading }] = useAxios({
    url: `checklist/${checklistId}`,
    method: "get",
  });

  const [actionItems, setActionItems] = useState(
    (checklist && checklist.actionItems) || []
  );

  const [
    createActionItem,
    creatingActionItem,
    allActionItemsData,
    loadingAllActionItems,
  ] = useCreateActionItem(setActionItems, checklistId, checklist);

  return (
    <Stack
      horizontal
      tokens={{
        childrenGap: 30,
      }}
    >
      <Stack.Item>
        <Text block as="h1" variant="xLarge" nowrap horizontalAlign="center">
          Checklist Action Items
        </Text>
        <ChecklistActionItemsContainer
          putActionItemsLoading={putActionItemsLoading}
          putActionItems={() => {
            const defaultRequirement = checklist?.completionRules === "Required Only" ? "Required" : "Not Required";
            putActionItems({
              data: actionItems.map((actionItem) => ({
                actionItemID: actionItem.actionItemID,
                checklistID: checklistId,
                orderNumber: actionItem.orderNumber,
                requirement: actionItem.requirement || defaultRequirement,
                validated: true,
              })),
              method: "put",
            });
          }}
          checklistId={checklistId}
          setIsModalCreateNewModalOpen={() => {
            setShowCreateActionItemForm(true);
          }}
          actionItems={actionItems}
          setActionItems={setActionItems}
          checklist={checklist}
          getChecklistLoading={getChecklistLoading}
          actionItemsData={allActionItemsData}
          loadingActionItems={loadingAllActionItems}
        />
      </Stack.Item>
      {showCreateActionItemForm && (
        <Card
          tokens={{
            childrenMargin: 25,
            maxWidth: "100%",
          }}
        >
          <Card.Section>
            <Stack verticalAlign='left'>
              <Text block as="h1" variant="xLarge" nowrap>
                Create an Action Item
              </Text>
              <Link
                styles={{ root: { fontSize: 13 } }}
                onClick={() => setShowCreateActionItemForm(false)}
              >
                {"< Close"}
              </Link>
            </Stack>
            <BasicInfoForm
              postForm={createActionItem}
              submitting={creatingActionItem}
              isWizard={true}
              onCreateSuccess={() => {
                // Close the panel - the action item list is automatically
                // refreshed by useCreateActionItem hook
                setShowCreateActionItemForm(false);
              }}
            />
          </Card.Section>
        </Card>
      )}
    </Stack>
  );
};

export default ChecklistActionItemsPage;
